import { DatePicker, DatePickerProvider } from "@origin-digital/ods-pickers";
import React from "react";
import { getNestedValue } from "../helper";
import { useFormikContext } from "formik";

interface DatePickerFieldProps {
  name: string;
  label: string;
  shouldDisableDate: (date: Date) => boolean;
  disabled?: boolean;
  helperText?: string;
  outerError?: string;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  name,
  label,
  shouldDisableDate,
  disabled,
  helperText: _helperText,
  outerError,
}) => {
  const { setFieldValue, values, errors } = useFormikContext();
  const error: string | undefined = outerError || getNestedValue(errors, name);
  const value: string | undefined | null = getNestedValue(values, name);
  const helperText =
    outerError || (disabled ? _helperText : error?.toString() || _helperText);

  const handleOnChange = React.useCallback(
    (date: Date | null) => {
      if (date != value) {
        setFieldValue(name, date);
      }
    },
    [name, setFieldValue, value]
  );

  return (
    <DatePickerProvider>
      <DatePicker
        id={name}
        label={label}
        muiProps={{
          slotProps: {
            textField: {
              variant: "outlined",
            },
          },
        }}
        onChange={handleOnChange}
        value={value}
        error={!!error}
        helperText={helperText}
        shouldDisableDate={shouldDisableDate}
        disabled={disabled}
      />
    </DatePickerProvider>
  );
};

export default DatePickerField;
